'use strict';

exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = function (classNameBuilder) {
    var __render = (0, _renderTag2.default)(classNameBuilder);
    return function (_ref) {
        var _ref$addBemClassName = _ref.addBemClassName,
            addBemClassName = _ref$addBemClassName === undefined ? true : _ref$addBemClassName,
            block = _ref.block,
            elem = _ref.elem,
            mods = _ref.mods,
            _ref$tag = _ref.tag,
            Tag = _ref$tag === undefined ? 'div' : _ref$tag,
            mix = _ref.mix,
            attrs = _ref.attrs,
            cls = _ref.cls,
            children = _ref.children;

        var typeOfBlock = typeof block === 'undefined' ? 'undefined' : _typeof(block);
        if (typeOfBlock === 'object') {
            block = block.block;
        } else if (typeOfBlock === 'function') {
            block = block.prototype.block;
        }

        return __render(addBemClassName, Tag, attrs, block, elem, mods, mix, cls, children);
    };
};

var _renderTag = require('./renderTag');

var _renderTag2 = _interopRequireDefault(_renderTag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }